var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevel2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 94c25.957 0 47-21.043 47-47S72.957 0 47 0 0 21.043 0 47s21.043 47 47 47Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8 76c16.017 0 29-12.984 29-29s-12.983-29-29-29c-16.016 0-29 12.984-29 29s12.984 29 29 29Z",
    fill: "#D5EFF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m31.5 33.3 3.3 6.6c.2.4.6.7 1.1.8l7.3 1.1c1.2.2 1.7 1.6.8 2.5l-5.3 5.2c-.3.3-.5.8-.4 1.3l1.3 7.3c.2 1.2-1 2.1-2.1 1.5l-6.6-3.4c-.4-.2-.9-.2-1.3 0L23 59.5c-1.1.6-2.3-.3-2.1-1.5l1.3-7.3c.1-.5-.1-.9-.4-1.3l-5.3-5.2c-.9-.8-.4-2.3.8-2.5l7.3-1.1c.5-.1.9-.4 1.1-.8l3.3-6.6c.5-1 2-1 2.5.1Zm35.2 0 3.3 6.6c.2.4.6.7 1.1.8l7.3 1.1c1.2.2 1.7 1.6.8 2.5l-5.3 5.2c-.3.3-.5.8-.4 1.3l1.3 7.3c.2 1.2-1 2.1-2.1 1.5l-6.6-3.4c-.4-.2-.9-.2-1.3 0l-6.6 3.4c-1.1.6-2.3-.3-2.1-1.5l1.3-7.3c.1-.5-.1-.9-.4-1.3l-5.3-5.2c-.9-.8-.4-2.3.8-2.5l7.3-1.1c.5-.1.9-.4 1.1-.8l3.3-6.6c.4-1.1 2-1.1 2.5 0Z",
    fill: "#FFD41F",
    stroke: "#F4C500",
    strokeWidth: 2.023
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel2);
export default __webpack_public_path__ + "static/media/level2.855f3cb8.svg";
export { ForwardRef as ReactComponent };